import { toast } from 'react-toastify'
import URL from 'src/apis/URL'
import { getMenus } from './menus'

export const getSubcategoryRequest = () => ({ type: 'GET_SUBCATEGORY_REQUEST' })
export const getSubcategorySuccess = (data) => ({ type: 'GET_SUBCATEGORY_SUCCESS', data })
export const getSubcategoryFailure = (error) => ({ type: 'GET_SUBCATEGORY_FAILURE', error })

export const addSubcategoryRequest = () => ({ type: 'ADD_SUBCATEGORY_REQUEST' })
export const addSubcategorySuccess = () => ({ type: 'ADD_SUBCATEGORY_SUCCESS' })
export const addSubcategoryFailure = (error) => ({ type: 'ADD_SUBCATEGORY_FAILURE', error })

export const updateSubcategoryRequest = () => ({ type: 'UPDATE_SUBCATEGORY_REQUEST' })
export const updateSubcategorySuccess = () => ({ type: 'UPDATE_SUBCATEGORY_SUCCESS' })
export const updateSubcategoryFailure = (error) => ({ type: 'UPDATE_SUBCATEGORY_FAILURE', error })

export const deleteSubcategoryRequest = () => ({ type: 'DELETE_SUBCATEGORY_REQUEST' })
export const deleteSubcategorySuccess = () => ({ type: 'DELETE_SUBCATEGORY_SUCCESS' })
export const deleteSubcategoryFailure = (error) => ({ type: 'DELETE_SUBCATEGORY_FAILURE', error })

export const getSubcategory = () => {
  return (dispatch) => {
    dispatch(getSubcategoryRequest())
    fetch(URL.BASE_URL + URL.END_POINT.subcategories, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(getSubcategorySuccess(data))
      })
      .catch((error) => {
        dispatch(getSubcategoryFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const addSubcategory = (newSubcategory) => {
  return (dispatch) => {
    dispatch(addSubcategoryRequest())
    fetch(URL.BASE_URL + URL.END_POINT.subcategories, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: newSubcategory,
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(addSubcategorySuccess())
        toast.success('Subcategory added successfully')
        dispatch(getMenus())
      })
      .catch((error) => {
        dispatch(addSubcategoryFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const updateSubcategory = (id, updatedSubcategory) => {
  return (dispatch) => {
    dispatch(updateSubcategoryRequest())
    fetch(URL.BASE_URL + URL.END_POINT.subcategories + id, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: updatedSubcategory,
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(updateSubcategorySuccess())
        toast.success('Subcategory updated successfully')
        dispatch(getMenus())
      })
      .catch((error) => {
        dispatch(updateSubcategoryFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const deleteSubcategory = (id) => {
  return (dispatch) => {
    dispatch(deleteSubcategoryRequest())
    fetch(URL.BASE_URL + URL.END_POINT.subcategories + id, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(deleteSubcategorySuccess())
        toast.success('Subcategory deleted successfully')
        dispatch(getMenus())
      })
      .catch((error) => {
        dispatch(deleteSubcategoryFailure(error.message))
        toast.error(error.message)
      })
  }
}

const initialState = {
  subcategories: [],
  loading: false,
  error: null,
}

export const subcategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_SUBCATEGORY_REQUEST':
    case 'ADD_SUBCATEGORY_REQUEST':
    case 'UPDATE_SUBCATEGORY_REQUEST':
    case 'DELETE_SUBCATEGORY_REQUEST':
      return { ...state, loading: true, error: null }
    case 'GET_SUBCATEGORY_SUCCESS':
      return { ...state, subcategories: action.data.subcategories, loading: false, error: null }
    case 'ADD_SUBCATEGORY_SUCCESS':
    case 'UPDATE_SUBCATEGORY_SUCCESS':
    case 'DELETE_SUBCATEGORY_SUCCESS':
      return { ...state, loading: false, error: null }
    case 'GET_SUBCATEGORY_FAILURE':
    case 'ADD_SUBCATEGORY_FAILURE':
    case 'UPDATE_SUBCATEGORY_FAILURE':
    case 'DELETE_SUBCATEGORY_FAILURE':
      return { ...state, loading: false, error: action.error }
    default:
      return state
  }
}
